import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persistedstate'

import ArticlesModule from './articles.js'
import CacheModule from './cache.js'
import ErrorsModule from './errors.js'
import MerlinModule from './merlin.js'
import PublicationsModule from './publications.js'
import StandardsModule from './standards.js'
import TagsModule from './tags.js'
import UnitGroupsModule from './unit_groups.js'
import UnitsModule from './units.js'
import UserModule from './user.js'
import SettingsModule from './settings.js'
import UtilitiesModule from './utilities.js'
import MediaModule from './media.js'
import PrintablesModule from './printables.js'
import AdminModule from './admin.js'
import WalkthroughModule from './walkthrough.js'
import ArticleLogModule from './article_log.js'
import CrosswordModule from './crossword.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        articles: ArticlesModule,
        cache: CacheModule,
        errors: ErrorsModule,
        merlin: MerlinModule,
        publications: PublicationsModule,
        standards: StandardsModule,
        tags: TagsModule,
        unit_groups: UnitGroupsModule,
        units: UnitsModule,
        user: UserModule,
        settings: SettingsModule,
        utilities: UtilitiesModule,
        media: MediaModule,
        printables: PrintablesModule,
        admin: AdminModule,
        walkthrough: WalkthroughModule,
        article_logs: ArticleLogModule,
        crossword: CrosswordModule,
    },
    plugins: [
        VuexPersistence({
            paths: ['errors', 'settings', 'user']
        })
    ]
})
